/* global $:false */

import "@babel/polyfill";

import '@cob/ui-genesis/less/main.less';
import '@cob/ui-reportm/less/reportm.less';
import './recordm/less/recordm.less';

// Components
import * as components from './recordm/fields/recordm.components.js'

import { ConfirmDialog, InfoDialog, SelectionDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';

import CustomResource from './recordm/recordm.customResource.js';
import DefinitionCreate from './recordm/recordm.definition.create.js';
import DefinitionDetail from './recordm/recordm.definition.detail.js';
import DomainDefinitions from './recordm/recordm.domainsdefinitions.js';
import InstanceCreate from './recordm/recordm.instance.create.js';
import InstanceDetail from './recordm/recordm.instance.detail.js';
import InstanceDuplicate from './recordm/recordm.instance.duplicate.js';
import InstanceGroupEdit from './recordm/recordm.instance.groupedit.js';
import RecordmCustomizingHelper from './recordm/helpers/recordm.customizing.js';
import ReportDetail from '@cob/ui-reportm/reportm.reportdetail.js';
import Reports from '@cob/ui-reportm/reportm.reports.js';
import RmImporterStatsDetails from "./recordm/recordm.importer.stats.details";
import SearchDefinition from './recordm/recordm.definition.search.js';
import SearchDomain from './recordm/recordm.domain.search.js';
import SearchRmImporterStats from "./recordm/recordm.importer.stats.search";

import cobapp from '@cob/ui-genesis/cob.app.js';
import fileUpload from '@cob/ui-genesis/helpers/cob.file-upload.js';
import runtimeloader from '@cob/ui-genesis/helpers/cob.runtimeloader.js';
import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

utils.extend(cobapp, new RecordmCustomizingHelper());

utils.extend(cobapp, {
   inFixMode: () => {
      const fix = new URL(document.location).searchParams.get('fix');
      return fix == 'true' || fix == '1'
   }
});

$(document).ready(function() {

   const settings = {
      /* eslint-disable-next-line  */
      app_version: APP_VERSION, //replaced at compile
      mode: function(){
         if ($('body').hasClass('naked')){
            return 'naked';
         }

         if(RegExp('naked=(1|true)').test(window.location.search)){
            return 'naked';
         }

         /* eslint-disable no-undef */
         if(typeof cob !== 'undefined' && cob.custom && cob.custom.mode){
            window.console.warn('DEPRECATED', 'cob.custom.mode() is deprecated. Please use cob.custom.naked(module, params).');
            if(cob.custom.mode() === 'naked' ){
               return "naked";
            }
         }
         /* eslint-enable no-undef */

         return 'normal'
      }
   }

   ui.dialogs = {ConfirmDialog, InfoDialog, SelectionDialog};
   ui.fileUploader = fileUpload;

   /* eslint-disable no-undef */
   if (typeof cob !== 'undefined') {
      // export components for dashboard
      cob.components = components
   }

   /* eslint-disable no-undef */
   if(typeof cob !== 'undefined' && cob.custom){

      if( typeof cob.custom.customize === 'function' ){
         cob.custom.customize(cobapp, { ...utils, ...runtimeloader(cobapp) }, ui);
      } else if (Array.isArray(cob.custom.customize)){
         const runtimeloaderInited = runtimeloader(cobapp)
         cob.custom.customize.forEach((func) => func(cobapp, { ...utils, ...runtimeloaderInited }, ui))

         // In case there's some import done at customizations2.js that finishes loading AFTER
         // the last line, we override cob.custom.customize.push to call any aditional costumization done
         cob.custom.customize.push = function(...args) {
            Array.prototype.push.apply(this, args);
            args[0](cobapp, { ...utils, ...runtimeloaderInited }, ui)
         }
      }

      if( typeof cob.custom.loginTemplate !== 'undefined' ){
         settings.loginTemplate = cob.custom.loginTemplate;
      }

      settings.getDefaultModuleUri = cob.custom.getDefaultModuleUri;
      settings.routingBaseSelector = cob.custom.routingBaseSelector
   }
   /* eslint-enable no-undef */

   if(settings.mode() === 'naked'){
      $('body').addClass('naked')
   }

   cobapp.init([
      {
         uri: [/\/cob\.custom-resource\/(.*)\/(.*)/],
         name: "custom-resource",
         constructor: CustomResource
      },
      {
         uri: [/\/domain\/(\d+)/, /\/domain\/(\d+)\/q=(.*)\/data=(.*)/, /\/domain\/(\d+)\/q=(.*)$/],
         name: "search-domain",
         constructor: SearchDomain
      },
      {
         uri: [/\/instance\/(\d+)/,/\/instance\/(\d+)\/data=([^&]*)/],
         name: "instance.detail",
         constructor: InstanceDetail
      },
      {
         uri: [/\/instance\/create\/(\d+)/, /\/instance\/create\/(\d+)\/data=([^&]*)/],
         name: "instance.create",
         constructor: InstanceCreate
      },
      {
         uri: [/\/instance\/duplicate\/(\d+)/],
         name: "instance.duplicate",
         constructor: InstanceDuplicate
      },
      {
         uri: [/\/instance\/groupedit\/(\d+)\/query=(.*)\/ids=(.*)/,
            /\/instance\/groupedit\/(\d+)\/query=(.*)\/ids=(.*)\/data=([^&]*)/],
         name: "instance.groupedit",
         constructor: InstanceGroupEdit
      },
      {
         baseUri: "/definitions",
         uri: [/\/definitions\/(\d+)/, /\/definitions\/(\d+)\/(a?q)=([^&]*)(?:&av=(-?\d+)?)?/, /\/definitions\/(\d+)\/(a?q)=([^&]*)(?:&av=(-?\d+)?)?(?:&filters=({.*}))?/],
         name: "search-definition",
         constructor: SearchDefinition
      },
      {
         baseUri: "/domains",
         uri: ["/domains",
            /\/domains\/filter=(.*)$/],
         name: "domains",
         constructor: DomainDefinitions
      },
      {
         uri: ["/definitions/create"],
         name: "definition.create",
         constructor: DefinitionCreate
      },
      {
         uri: [/\/definitions\/(\d+)\/edit/],
         name: "definition.edit",
         constructor: DefinitionDetail
      },
      {
         baseUri: "/reports",
         uri: ["/reports"],
         name: "reports",
         constructor: Reports
      },
      {
         // Report file names may contain letters and "_" (\w), numbers (\d) and the "-"
         uri: [/\/reports\/([\w\d+-]+)\/([\w\d,]+)/, /\/reports\/([\w\d+-]+)/],
         name: "reportdetail",
         constructor: ReportDetail
      },
      {
         uri: ["/importer-stats", /\/importer-stats\/(a?q)=([^&]*)(?:&av=(\d+))?/],
         name: "importer-stats",
         constructor: SearchRmImporterStats
      },
      {
         uri: [/\/importer-stats\/([\w\d+-]+)/,/\/importer-stats\/([\w\d+-]+)\/(a?q)=([^&]*)(?:&av=(\d+))?/],
         name: "importer-stats-details",
         constructor: RmImporterStatsDetails
      }
   ], settings);
});
